import { render, staticRenderFns } from "./rtfPreview.vue?vue&type=template&id=5f696053&scoped=true"
import script from "./rtfPreview.vue?vue&type=script&lang=js"
export * from "./rtfPreview.vue?vue&type=script&lang=js"
import style0 from "./rtfPreview.vue?vue&type=style&index=0&id=5f696053&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f696053",
  null
  
)

export default component.exports